import { useNavigate } from "react-router-dom";
import { FaWpforms, FaUsers, FaChartBar, FaLayerGroup, FaFacebook, FaShieldAlt } from "react-icons/fa";
import { PublicNav, PublicFooter } from "../components/PublicLayout";
import "./LandingPage.css";

const ProductPage = () => {
  const navigate = useNavigate();

  return (
    <div className="lp-root">
      <PublicNav />

      {/* Hero */}
      <section className="lp-hero" style={{ padding: "80px 20px 100px" }}>
        <div className="lp-hero-inner">
          <div className="lp-hero-badge">Product</div>
          <h1 className="lp-hero-title" style={{ fontSize: "3rem" }}>
            Everything you need to <span className="lp-hero-gradient">run better ads</span>
          </h1>
          <p className="lp-hero-sub">
            A guided workflow built around how you actually manage Facebook and Instagram campaigns — not how Meta's Ads Manager was designed.
          </p>
          <div className="lp-hero-ctas">
            <button className="lp-hero-btn-main" onClick={() => navigate("/signup")}>Get Started Free</button>
            <button className="lp-hero-btn-ghost" onClick={() => navigate("/pricing")}>View Pricing →</button>
          </div>
        </div>
      </section>

      {/* Features */}
      <section className="lp-features">
        <div className="lp-section-inner">
          <div className="lp-section-head">
            <h2 className="lp-section-title">Built for real ad workflows</h2>
            <p className="lp-section-sub">No feature bloat. Just the tools you need to create, manage, and track campaigns.</p>
          </div>
          <div className="lp-features-grid">
            {[
              {
                icon: <FaWpforms />,
                title: "Guided Campaign Builder",
                desc: "Step-by-step wizard walks you through every decision — objective, audience, creative, budget. No guessing, no getting lost.",
              },
              {
                icon: <FaUsers />,
                title: "Audience Management",
                desc: "Build and save custom audiences. Reuse them across campaigns without rebuilding targeting from scratch every time.",
              },
              {
                icon: <FaChartBar />,
                title: "Performance Dashboard",
                desc: "Monitor impressions, clicks, spend, and CTR from a clean overview. See what's working without digging through Ads Manager.",
              },
              {
                icon: <FaLayerGroup />,
                title: "Multi-Account Support",
                desc: "Manage multiple ad accounts and switch between them instantly. Built for freelancers and agencies managing client accounts.",
              },
              {
                icon: <FaFacebook />,
                title: "Facebook & Instagram",
                desc: "Create campaigns that run on both platforms. Manage your connected pages and Instagram accounts from one place.",
              },
              {
                icon: <FaShieldAlt />,
                title: "Secure Meta Connection",
                desc: "Connect via Meta's official OAuth. Your credentials never touch our servers — only the access tokens needed to manage your campaigns.",
              },
            ].map((f, i) => (
              <div className="lp-feature-card" key={i}>
                <div className="lp-feature-icon">{f.icon}</div>
                <h3 className="lp-feature-title">{f.title}</h3>
                <p className="lp-feature-desc">{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* How it works */}
      <section className="lp-how">
        <div className="lp-section-inner">
          <div className="lp-section-head">
            <h2 className="lp-section-title">Up and running in minutes</h2>
            <p className="lp-section-sub">Three steps, no technical setup required</p>
          </div>
          <div className="lp-steps">
            {[
              { n: "1", title: "Connect", desc: "Link your Facebook Business account via Meta's secure login. Takes about 60 seconds." },
              { n: "2", title: "Create", desc: "Launch your first campaign using the step-by-step wizard. Smart defaults, clear choices." },
              { n: "3", title: "Track", desc: "Monitor performance from your dashboard. See spend, reach, clicks, and results in one view." },
            ].map((s, i) => (
              <div className="lp-step" key={i}>
                <div className="lp-step-num">{s.n}</div>
                <h3 className="lp-step-title">{s.title}</h3>
                <p className="lp-step-desc">{s.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="lp-cta">
        <div className="lp-cta-inner">
          <h2 className="lp-cta-title">See it for yourself</h2>
          <p className="lp-cta-sub">Sign up free and connect your Meta account — no credit card needed.</p>
          <button className="lp-hero-btn-main" onClick={() => navigate("/signup")}>Get Started Free</button>
          <p className="lp-hero-trust" style={{ color: "rgba(255,255,255,0.6)" }}>No credit card required</p>
        </div>
      </section>

      <PublicFooter />
    </div>
  );
};

export default ProductPage;
